export default __webpack_public_path__ + "static/media/thienach.8f369a8f.png";